// extracted by css-extract-rspack-plugin
export default {"cls1":"TransactionalPricingModal-cls1_Jsv","cls2":"TransactionalPricingModal-cls2_9mx TransactionalPricingModal-cls1_Jsv"};